"use client";

import { BarChart3, CalendarCheck, MessageSquareText, UserRoundPlus } from "lucide-react";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";

const METRICS = [
  {
    icon: MessageSquareText,
    label: "Conversations answered",
    hint: "Phone, website chat, SMS, email, and video, on the plan that includes each channel.",
  },
  {
    icon: UserRoundPlus,
    label: "Leads captured",
    hint: "Name, contact, and intent captured when humans are busy.",
  },
  {
    icon: CalendarCheck,
    label: "Appointments booked",
    hint: "Appointment requests captured, or booked when a calendar is connected.",
  },
  {
    icon: BarChart3,
    label: "Human handoffs",
    hint: "Moments your team took over—with full conversation context.",
  },
] as const;

export function SiteGlueHomeImpactReport() {
  return (
    <HomeSection id="impact-report" tone="slate">
      <FadeIn className="mx-auto max-w-2xl text-center">
        <HomeEyebrow>Monthly AI Impact Report</HomeEyebrow>
        <HomeHeading className="mx-auto">See what your agent handled this month.</HomeHeading>
        <HomeLead className="mx-auto">
          Outcomes—not vanity metrics. Understand how your AI teammate helped the business while
          keeping people in the loop.
        </HomeLead>
      </FadeIn>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {METRICS.map((m, i) => (
          <FadeIn key={m.label} delay={0.06 * (i + 1)}>
            <div className="h-full rounded-2xl border border-slate-200 bg-white p-5">
              <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#4f81bd]/10 text-[#4f81bd]">
                <m.icon className="h-5 w-5" strokeWidth={1.75} aria-hidden />
              </div>
              <h3 className="mt-4 text-base font-semibold text-slate-900">{m.label}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{m.hint}</p>
            </div>
          </FadeIn>
        ))}
      </div>
      <p className="mt-8 text-center text-xs text-slate-500">
        Impact ranges depend on your volume, channels, and plan—SiteGlue never invents financial
        projections.
      </p>
    </HomeSection>
  );
}
